import { Injectable, inject } from '@angular/core';
import { HisNavigationService } from './his-navigation.service';

@Injectable({providedIn: 'root'})
export class HisGlobalDataService {
    private navigationService = inject(HisNavigationService);

    private readonly SUBMIT_SUCCESS_MESSAGE = 'submitSuccessMessage';

    private data: Map<string, any> = new Map<string, any>();
    private dirty: Map<string, any> = new Map<string, any>();

    setData( key: string, value: any ) {
        if (key === this.SUBMIT_SUCCESS_MESSAGE && value) {
            this.navigationService.dirty = false;
        }

        this.data.set( key, value );
        this.dirty.set( key, this.navigationService.dirty );
    }

    getData( key: string, restoreDirty?: boolean ) {
        if (restoreDirty && this.getDirty(key)) {
            // getData is typically called before dirtyTracking is enabled
            queueMicrotask(() => {
                this.navigationService.dirty = true;
            });
        }
        return this.data.get( key );
    }

    getDirty( key: string ) {
        return this.dirty.get( key );
    }

    markDirty( key: string ) {
        this.dirty.set( key, true );
    }

    removeData( key: string ) {
        this.data.delete( key );
        this.dirty.delete( key );
    }
}
